import {useTranslation} from 'react-i18next';
import {Button} from '@guestapp/old-ui-kit';
import incompleteIcon from 'assets/icons/incomplete.svg?no-inline';
import {ModalSheet} from 'components/common/ModalSheet/ModalSheet';
import {ModalContent} from 'components/Modal/Modal';

type Props = {
  open: boolean;
  onRetry: () => void;
  onBackToStart: () => void;
};

export function NotFoundReservationModal({open, onRetry, onBackToStart}: Props) {
  const {t} = useTranslation('identity-verification');

  return (
    <ModalSheet
      isOpenModalSheet={open}
      maxWidth={375}
      modalMobileHeight={'480px'}
      className="not-found-reservation-modal"
      withCloseButton
      onClose={onRetry}
    >
      <div className="space-y-8 flex flex-col items-center w-full">
        <ModalContent
          title={t('not_found_reservation_modal.title')}
          iconSrc={incompleteIcon}
          iconProps={{width: 67, height: 67}}
          text={t('not_found_reservation_modal.description')}
        />
        <div className="flex flex-col gap-3 w-full">
          <Button
            onClick={onRetry}
            label={t('not_found_reservation_modal.try_again')}
            className="w-full"
          />
          <Button
            link
            onClick={onBackToStart}
            label={t('not_found_reservation_modal.back_to_start')}
            className="w-full justify-center"
          />
        </div>
      </div>
    </ModalSheet>
  );
}
